import {ref} from 'vue';
type OnCloseCallback = () => void;

interface EditorDialogAboutShowOptions {
	versionPolygonjs: string;
	versionEditor: string;
}

export class EditorDialogWAboutStoreControllerClass {
	private static _instance: EditorDialogWAboutStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogWAboutStoreControllerClass());
	}

	private _displayed = ref(false);
	private _versionPolygonjs = ref('');
	private _versionEditor = ref('');
	private _on_close_callback: OnCloseCallback | undefined;
	private constructor() {}

	private _reset() {
		this._displayed.value = false;
	}

	displayed(): boolean {
		return this._displayed.value;
	}
	versionPolygonjs(): string {
		return this._versionPolygonjs.value;
	}
	versionEditor(): string {
		return this._versionEditor.value;
	}

	// mutations
	async show(options: EditorDialogAboutShowOptions): Promise<void> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._versionPolygonjs.value = options.versionPolygonjs;
			this._versionEditor.value = options.versionEditor;
			this._on_close_callback = resolve;
		});
	}
	hide() {
		this._reset();
		if (this._on_close_callback) {
			this._on_close_callback();
		}
	}
}

export const EditorDialogAboutStoreController = EditorDialogWAboutStoreControllerClass.instance();
